export const roundNumber = (value, decimalPlaces = 2) => Number(value.toFixed(decimalPlaces || 2));

const compactCurrencyFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  notation: 'compact',
  // Explícito porque o padrão varia com a versão do ICU (Node 18 gera "R$ 13,0 mil", o Node 24 "R$ 13 mil")
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
});

export const formatCompactCurrency = (value) => compactCurrencyFormatter.format(value);

export const formatInteger = (value) => value.toLocaleString('pt-BR');
